﻿<div>
    <div class="sub-section-header">
        <h1 class="title">Underwriting Decision</h1>
        <span class="actions">
            Last Updated: <span *ngIf="lastUpdated; else never">{{ lastUpdated | date: 'M/d/yy, h:mm a' }}</span>
            <ng-template #never>Never</ng-template>
        </span>
    </div>

    <form [formGroup]="decisionForm" novalidate autocomplete="off">
        <mat-card appearance="outlined">
            <mat-card-header>Enable Section Workflow</mat-card-header>
            <mat-card-subtitle>Selecting 'None' will use default decision workflow.</mat-card-subtitle>

            <mat-card-content *ngIf="!sectionsLoaded || !accountSettingsLoaded">
                <mat-spinner mode="indeterminate" diameter="30"></mat-spinner>
            </mat-card-content>

            <mat-card-content *ngIf="sectionsLoaded && accountSettingsLoaded">
                <div class="section-select">
                    <auto-suggest
                        disableSort="true"
                        class="auto-width-panel"
                        [list]="sections"
                        [formControlName]="AccountSettings.UWDecisionSection"
                        (newValueChanges)="handleSectionChange($event)"
                        field="name"
                        dataKey="id">
                    </auto-suggest>
                </div>
            </mat-card-content>

            <mat-card-content *ngIf="errorMessage">
                {{ errorMessage }}
            </mat-card-content>

            <mat-card-content *ngIf="!rulesLoaded || !accountSettingsLoaded">
                <mat-spinner mode="indeterminate" diameter="30"></mat-spinner>
            </mat-card-content>

            <mat-card-content *ngIf="rulesLoaded && accountSettingsLoaded">
                <div class="sub-heading pt-2">Disable Update Decision</div>
                <div class="pb-2">Optional rule. If the selected rule evaluates to true, the Update Decision button is disabled.</div>
                <auto-suggest
                    class="rule-select"
                    [list]="rules"
                    disableSort="true"
                    placeholder="Optional rule"
                    field="name"
                    dataKey="id"
                    formControlName="uwDecisionDisableUpdateRuleId"
                    [disabled]="!isSectionWorkflowSelected()"
                    (newValueChanges)="handleRuleChange($event)">
                </auto-suggest>
            </mat-card-content>
        </mat-card>
    </form>
</div>